/**
 * Creates a `Validator` from the given `ValidateFn` and error message.
 *
 * If the `ValidateFn` returns true, the `Validator` returns `undefined`
 *
 * If the `ValidateFn` returns false, the `Validator` returns the error message
 */
export function validator(fn, errorMessage) {
    return function (value, props) {
        var getErrorMessage = function () {
            return typeof errorMessage === 'string'
                ? errorMessage
                : errorMessage(value, props);
        };
        return !fn(value, props) ? getErrorMessage() : undefined;
    };
}
//# sourceMappingURL=validator.js.map